import { useEffect, useRef } from "react";

function AudioComponent({ track, muted }) {
  const audioRef = useRef(null);


  useEffect(() => {
    if (track && audioRef.current) {
      track.attach(audioRef.current);
    }

    return () => {
      if (track && audioRef.current) {
        track.detach(audioRef.current);
      }
    };
  }, [track]);

  

  return <audio ref={audioRef} /* id={track.sid} */ muted={muted} autoPlay/>;
}

export default AudioComponent;
